import React from 'react';

import './style.css';
import './mobileStyles.css';
import { isMobile } from '../../helpers/utils';

const LinkButton = props => {
    const { href, text } = props;

    return (
        <button
            aria-label={text}
            aria-live={`polite`}
            tabIndex={0}
            className={isMobile() ? `link-button link-button-mobile mobile-font-family` : 'link-button'}
            onClick={() => window.location.href = href}>
            {text}
            <span className="sr-only">This will take you to the add/edit delivery method page.</span>
        </button>
    );
};

export default LinkButton;
